import { useState, useEffect } from 'react';
import Api from '../api/api';
import { cameraLogos } from '../../utilities/cameraLogos'; 
import Loader from '../shared/loader';
import Pagination from '../shared/pagination';
import api from '../api/api';
import stringHelpers from '../../utilities/stringHelpers';
import arrayUtilities from '../../utilities/arrayUtilities';
import { Link } from 'react-router-dom';
import { saveAs } from 'file-saver';
import { toDateTimeString } from '../../utilities/dateUtilities';
import { Modal } from 'react-bootstrap';
import { SearchBarWithDebounce } from '../shared/searchBarWithDebounce';
import { FiltersModalTrigger } from '../shared/filtersModalTrigger';
import { AppliedFilterPill, renderTagFilterItemLabel } from '../shared/appliedFilterPill';
import appliedFiltersUtilities from '../../utilities/appliedFiltersUtilities';
import { CameraDataFiltersModal } from './filters-modals/CameraDataFiltersModal';
function CameraData(props) {
    const [cameraData, setCameraData] = useState(null);

    const [cameraFromDate, setCameraFromDate] = useState(null);
    const [cameraToDate, setCameraToDate] = useState(null);

    const [siteId, setSiteId] = useState("");
    const [cameraSearch, setCameraSearch] = useState(null);
    const [vrm, setVrm] = useState("");
    const [vrmLoading, setVrmLoading] = useState("");

    const [cameraLastPage, setCameraLastPage] = useState(false);
    const [cameraPageNumber, setCameraPageNumber] = useState(0);
    const [cameraLoading, setCameraLoading] = useState(true);
    const [cameraPageCount, setCameraPageCount] = useState(0);  
    const [selectedCamera, setSelectedCamera] = useState("")
    const [selectedTags, setSelectedTags] = useState([])
    const [direction, setDirection] = useState("")
    const [cameras, setCameras] = useState([])
    const [cameraDataModal, setCameraDataModal] = useState(null);

    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showFilterPills, setShowFilterPills] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);

    const getCameras = (siteId) => {
        if (!stringHelpers.isNullOrEmpty(siteId)) {
            Api.getSiteCameras(
                data => {
                    setCameras(data)
                },
                error => {
                    console.log(error)
                },
                props.organisationId,
                siteId,
                props.token
            )
        } else {
            Api.getCameras(
                0,
                data => {
                    setCameras(data)
                },
                error => {
                    console.log(error)
                },
                props.organisationId,
                props.token
            )
        }
        setSelectedCamera("")

    }

    const getCameraData = function (search = cameraSearch, site = siteId, fromDate = cameraFromDate, toDate = cameraToDate, page = cameraPageNumber, camera = selectedCamera, tagIds = selectedTags, motion = direction) {
        setCameraLoading(true);
        Api.getCameraData(
            (data) => {
                setCameraData(data);
                setVrmLoading(false);
                setCameraLoading(false);
            },
            (error) => {
                console.log(error)
                setCameraLoading(false);
            },
            !stringHelpers.isNullOrEmpty(search) ? search : null, !stringHelpers.isNullOrEmpty(site) ? site : null, fromDate, toDate, page, 0,
            !stringHelpers.isNullOrEmpty(camera) ? camera : null,
            tagIds,
            !stringHelpers.isNullOrEmpty(motion) ? motion : null,
            props.organisationId,
            props.token
        )
    };

    const changeCameraPageNumber = function (num) {
        setCameraPageNumber(num);
    };

    const isLastPageCamera = function () {
        if (cameraData !== null && cameraData !== undefined) {
            setCameraLastPage(false)
            setCameraPageCount(Math.ceil(cameraData.totalCount / 100));
            if (cameraPageNumber + 1 >= Math.ceil(cameraData.totalCount / 100)) {
                setCameraLastPage(true)
            }
        }
    };

    const clearFilters = function () {
        setCameraToDate(null);
        setCameraFromDate(null);
        setSiteId("");
        setSelectedCamera("");
        setSelectedTags([]);
        setDirection("");
        getCameras("");
        setAppliedFilters(null);
        setShowFilterPills(false);
        setCameraPageNumber(0);
        getCameraData(cameraSearch, null, null, null, 0, "", [], "");
    }

    const clearFilterByLabel = (label) => {
        switch (label) {
            case "Site":
                setSiteId("")
                setSelectedCamera("")
                getCameras("")
                getCameraData(cameraSearch, null, cameraFromDate, cameraToDate, 0, null, selectedTags)
                break
            case "Camera":
                setSelectedCamera("")
                getCameraData(cameraSearch, siteId, cameraFromDate, cameraToDate, 0, null, selectedTags)
                break
            case "From":
                setCameraFromDate(null)
                getCameraData(cameraSearch, siteId, null, cameraToDate, 0, selectedCamera, selectedTags)
                break
            case "To":
                setCameraToDate(null)
                getCameraData(cameraSearch, siteId, cameraFromDate, null, 0, selectedCamera, selectedTags)
                break
            case "Date Range":
                setCameraFromDate(null)
                setCameraToDate(null)
                getCameraData(cameraSearch, siteId, null, null, 0, selectedCamera, selectedTags)
                break
            case "Tags":
                setSelectedTags([])
                getCameraData(cameraSearch, siteId, cameraFromDate, cameraToDate, 0, selectedCamera, [])
                break
            case "Direction":
                setDirection("")
                getCameraData(cameraSearch, siteId, cameraFromDate, cameraToDate, 0, selectedCamera, selectedTags, "")
                break
            default:
                break
        }
        setCameraPageNumber(0)
    }

    const handleFilterPillClose = closedLabel => {
        clearFilterByLabel(closedLabel)
        setAppliedFilters(prevState => {
            const updatedFilters = { ...prevState }
            if (closedLabel === "From" || closedLabel === "To" || closedLabel === "Date Range") {
                updatedFilters.From = null
                updatedFilters.To = null
                updatedFilters["Date Range"] = null
            } else if (closedLabel === "Site") {
                updatedFilters.Site = null
                updatedFilters.Camera = null
            } else {
                updatedFilters[closedLabel] = null
            }
            return appliedFiltersUtilities.hasRemainingFilters(updatedFilters) ? updatedFilters : null
        })
    }

    const handleFilterPillItemRemove = (label, remainingIds) => {
        setAppliedFilters(prevState => appliedFiltersUtilities.keepMultiSelectionItems(prevState, label, remainingIds))
        removeMultiSelectFilterItemByLabel(label, remainingIds)
    }

    const removeMultiSelectFilterItemByLabel = (label, remainingIds) => {
        switch (label) {
            case "Tags":
                setSelectedTags(remainingIds)
                getCameraData(cameraSearch, siteId, cameraFromDate, cameraToDate, 0, selectedCamera, remainingIds)
                break
            default:
                break
        }
        setCameraPageNumber(0)
    }

    const editVrm = function (id) {
        //set loader
        var noSpecialChars = new RegExp("^[0-9,a-z]*$");
        if (!noSpecialChars.test(vrm)) {
            setVrmLoading(true);

            api.editCameraData(
                () => {
                    getCameraData();
                    setVrm("");
                },
                () => setVrmLoading(false),
                props.organisationId, id, vrm,
                props.token
            )
        }
        else {
            setVrmLoading(false);
        }
    }

    useEffect(() => {
        isLastPageCamera();
    }, [cameraData]);

    useEffect(() => {
        setCameraLoading(true);
        getCameraData(cameraSearch, siteId, cameraFromDate, cameraToDate, cameraPageNumber, selectedCamera, selectedTags);
    }, [cameraPageNumber])

    useEffect(() => {
        getCameraData(cameraSearch, siteId, cameraFromDate, cameraToDate, cameraPageNumber, selectedCamera, selectedTags);
        getCameras()
    }, [])

    const handleExport = function (search = cameraSearch, site = siteId, fromDate = cameraFromDate, toDate = cameraToDate, page = cameraPageNumber, camera = selectedCamera, tagIds = selectedTags, motion = direction) {
        setCameraLoading(true)
        api.getCameraData(
            (blob, filename) => { saveAs(blob, filename); setCameraLoading(false) },
            () => setCameraLoading(false),
            search, !stringHelpers.isNullOrEmpty(site) ? site : null, fromDate, toDate, page, 1,
            !stringHelpers.isNullOrEmpty(camera) ? camera : null,
            tagIds,
            !stringHelpers.isNullOrEmpty(motion) ? motion : null,
            props.organisationId,
            props.token
        )
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card mb-3">
                            <div className="card-header">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h5 className="mb-0 text-nowrap">
                                            Camera Data
                                        </h5>
                                    </div>
                                    <div className="align-items-center d-flex">
                                        <div className='mr-2'>
                                            <SearchBarWithDebounce
                                                onSearchQueryChange={query => {
                                                    setCameraSearch(query);
                                                    setCameraPageNumber(0);
                                                    getCameraData(query, siteId, cameraFromDate, cameraToDate, 0, selectedCamera, selectedTags);
                                                }}
                                            />
                                        </div>
                                        <div className='mr-2'>
                                            <FiltersModalTrigger onClick={() => setShowFiltersModal(true)} />
                                        </div>
                                        <button className="btn btn-primary btn-sm ml-1 nowrap" onClick={() => { setCameraLoading(true); getCameraData(cameraSearch, siteId, cameraFromDate, cameraToDate, cameraPageNumber, selectedCamera, selectedTags); }}><i className="fas fa-redo"></i> Refresh</button>
                                        <button
                                        className="btn btn-dark btn-sm mr-1 ml-1 nowrap"
                                        onClick={ () => handleExport(cameraSearch, siteId, cameraFromDate, cameraToDate, cameraPageNumber, selectedCamera, selectedTags) }>
                                        <i className="fas fa-download"></i> Export
                                    </button>
                                    </div>
                                </div>
                            </div>
                            {
                                showFilterPills && appliedFilters &&
                                <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                                    {
                                        Object.entries(appliedFilters).map(
                                            ([label, value]) => <AppliedFilterPill
                                                key={ label }
                                                label={ label }
                                                value={ value }
                                                renderItemLabel={ renderTagFilterItemLabel }
                                                onTextClick={ () => setShowFiltersModal(true) }
                                                onCloseClick={ handleFilterPillClose }
                                                onRemoveItem={ handleFilterPillItemRemove }
                                            />
                                        )
                                    }
                                    {appliedFilters && Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={() => clearFilters()}>Clear all filters</button>}
                                </div>
                            }
                            <div className="card-body bg-light border-top details-container p-0" id="camera-data-list" aria-labelledby="Allow List" data-parent="#camera-data">
                                <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                    <thead className="bg-200 text-900">
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>Read VRM</th>
                                            <th>Images</th>
                                            <th>&nbsp;</th>
                                            <th>Confidence</th>
                                            <th>Site</th>
                                            <th>Camera</th>
                                            <th>Direction</th>
                                            <th>ROI</th>
                                            <th>Read Timestamp</th>
                                            <th>Received Timestamp</th>
                                            <th>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {cameraLoading && <><tr>
                                            <td colSpan={12}>
                                                <Loader />
                                            </td></tr></>}
                                        {!cameraLoading && cameraData !== null && cameraData.items !== undefined && cameraData.items.map((item, i) => {
                                            i++;

                                            if (!item.imageUrls) {
                                                return null;
                                            }

                                            var direction = item.motion?.toString();

                                            if (!stringHelpers.isNullOrEmpty(direction)) {
                                                direction = direction[0].toUpperCase() + direction.substring(1);
                                            }

                                            var buttonThumbId = '#button-thumb-' + item.id;
                                            var modalThumbId = '#modal-thumb-' + item.id;
                                            var buttonPlateId = '#button-plate-' + item.id;
                                            var modalPlateId = '#modal-plate-' + item.id;

                                            var plateImageId = '#plate-thumb-' + item.id;
                                            var plateImageModalId = '#plate-thumb-modal-' + item.id;

                                            var siteDetailsUrl = `/organisation/${props.organisationId}/client/${props.sites.find(site => site.id === item.siteId)?.clientId}/site/${item.siteId}`;
                                            var cameraDetailsUrl = `/organisation/${props.organisationId}/site/${item.siteId}/camera/${item.cameraId}`
                                            let confidenceClass = item.confidence > 90 ? "bg-success" : (item.confidence > 60 ? "bg-warning" : "bg-danger");
                                            const cameraLogo = cameraLogos[item.cameraType]
                                            return (

                                                <tr key={item.id}>
                                                    <td>
                                                        {
                                                            cameraLogo === undefined || stringHelpers.isNullOrEmpty(cameraLogo.imageUrl)
                                                            ? <i className='far fa-question-circle fa-2x text-muted'></i>
                                                            : <img className='camera-logo' src={cameraLogo.imageUrl} alt={cameraLogos[item.cameraType].title} />
                                                        }
                                                    </td>
                                                    <td>
                                                        <button className="button-no-style number-plate-link" id={buttonPlateId.substring(1)} data-target={modalPlateId} data-toggle="modal"><h6 className="mb-0 small-number-plate">{item.vrm}</h6></button>

                                                        <div className="modal fade" id={modalPlateId.substring(1)} role="dialog" data-parent={buttonPlateId} aria-labelledby={modalPlateId}>
                                                            <div className="modal-dialog raw-data-pane" role="document">
                                                                <div className="modal-content">
                                                                    <div className="modal-header">
                                                                        <h5 className="modal-title">Edit VRM</h5>
                                                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                                            <span aria-hidden="true">&times;</span>
                                                                        </button>
                                                                    </div>
                                                                    <div className="modal-body">
                                                                        {!vrmLoading &&
                                                                            <div className='row justify-content-center align-items-center'>
                                                                                <div className='col-12'>
                                                                                    <img src={item.imageUrls[0]} className="m-1" />

                                                                                </div>
                                                                                <div className='col-6'>
                                                                                    <img src={item.imageUrls[1]} className="m-1" />

                                                                                </div>
                                                                                <div className='col-6'>
                                                                                    <div className="form-group mb-1">
                                                                                        <input className="form-control mb-1 small-number-plate" type="text" placeholder={item.vrm} value={vrm} onChange={(e) => setVrm(e.target.value.toUpperCase())} />
                                                                                    </div>
                                                                                </div>
                                                                                {vrm !== "" &&
                                                                                    <div className='col-auto'>
                                                                                        <div className='button-container'>
                                                                                            <button className='btn btn-sm btn-success m-1' onClick={() => editVrm(item.id)}>Edit</button>
                                                                                            <button className='btn btn-sm btn-danger m-1' onClick={() => setVrm("")}>Cancel</button>
                                                                                        </div>
                                                                                    </div>}
                                                                            </div>
                                                                        }
                                                                        {vrmLoading && <div className="small-loader">
                                                                            <Loader />
                                                                        </div>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {!arrayUtilities.isNullOrEmpty(item.imageUrls) && item.imageUrls.length > 1 &&
                                                            <>
                                                                <button className='button-no-style number-plate-button px-0' id={plateImageId} data-target={plateImageModalId} data-toggle='modal'>
                                                                    <img height={50} src={item.imageUrls[1]} className="m-1" />
                                                                </button>

                                                                <div className="modal fade" id={plateImageModalId.substring(1)} role="dialog" data-parent={plateImageId} aria-labelledby={plateImageModalId}>
                                                                    <div className="modal-dialog raw-data-pane" role="document">
                                                                        <div className="modal-content">
                                                                            <div className="modal-header">
                                                                                <h5 className="modal-title">{item.vrm}</h5>
                                                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                                                    <span aria-hidden="true">&times;</span>
                                                                                </button>
                                                                            </div>
                                                                            <div className="modal-body">
                                                                                <div className='row justify-content-center'>
                                                                                    <img src={item.imageUrls[1]} className="m-1" />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }
                                                    </td>
                                                    <td>
                                                        {!arrayUtilities.isNullOrEmpty(item.imageUrls) && item.imageUrls.length > 0 && <>
                                                            <button className="button-no-style number-plate-link" id={buttonThumbId.substring(1)} data-target={modalThumbId} data-toggle="modal">
                                                                <img height={50} src={item.imageUrls[0]} className="m-1" />
                                                            </button>


                                                            <div className="modal fade" id={modalThumbId.substring(1)} role="dialog" data-parent={buttonThumbId} aria-labelledby={modalThumbId}>
                                                                <div className="modal-dialog raw-data-pane" role="document">
                                                                    <div className="modal-content">
                                                                        <div className="modal-header">
                                                                            <h5 className="modal-title">{item.vrm}</h5>
                                                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                                                <span aria-hidden="true">&times;</span>
                                                                            </button>
                                                                        </div>
                                                                        <div className="modal-body">
                                                                            <div className='row justify-content-center'>
                                                                                <img src={item.imageUrls[0]} className="m-1" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>}
                                                    </td>
                                                    <td>
                                                        <div class="progress" style={{minWidth: "60px"}}>
                                                        <div class={`progress-bar text-left pl-1 ${confidenceClass}`} role="progressbar" style={{width: `${item.confidence}%`}} aria-valuenow={item.confidence} aria-valuemin="0" aria-valuemax="100">
                                                            {item.confidence}%
                                                        </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <Link to={siteDetailsUrl}>
                                                            <h6 className="m-0">{item.siteName}</h6>
                                                        </Link>
                                                    </td>
                                                    <td>
                                                        <Link to={cameraDetailsUrl}>
                                                            <h6 className="m-0">{item.cameraName}</h6>
                                                        </Link>
                                                    </td>
                                                    <td>{direction}</td>
                                                    <td>{item.roi}</td>
                                                    <td>
                                                        {!stringHelpers.isNullOrEmpty(item.timestamp) && toDateTimeString(item.timestamp, true)}
                                                    </td>
                                                    <td>
                                                        {!stringHelpers.isNullOrEmpty(item.receivedTimestamp) && toDateTimeString(item.receivedTimestamp, true)}
                                                    </td>
                                                    <td className='text-right pr-4'>
                                                        <button onClick={ () => setCameraDataModal(item) } className="btn btn-none p-0 m-0" type="button">
                                                            <i className="fas fa-eye"></i>
                                                        </button>
                                                    </td>
                                                </tr>

                                            )
                                        }
                                        )}
                                    </tbody>
                                </table>
                                <div className="d-flex justify-content-center row align-items-center">
                                    <div className="col-auto align-items-center">
                                        {!cameraLoading &&
                                            <Pagination totalResults={cameraData.totalCount} currentPage={cameraPageNumber} changePageNumber={changeCameraPageNumber} />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    cameraDataModal &&
                    <Modal size='xl' show onHide={ () => setCameraDataModal(null) } centered>
                        <Modal.Header className='d-flex align-items-center justify-content-between'>
                            <Modal.Title className='d-flex align-items-center'>
                                <div style={ { width: "100px" } } className='mr-2'>
                                    {
                                        cameraLogos[cameraDataModal.cameraType] === undefined || stringHelpers.isNullOrEmpty(cameraLogos[cameraDataModal.cameraType].imageUrl)
                                            ? <i className='far fa-question-circle fa-2x text-muted'></i>
                                            : <img width="100%" className='camera-logo' src={ cameraLogos[cameraDataModal.cameraType].imageUrl } alt={ cameraLogos[cameraDataModal.cameraType].title } />
                                    }
                                </div>
                                {cameraDataModal.cameraName}
                            </Modal.Title>
                            <button className='btn btn-none m-0 p-0' type='button' onClick={ () => setCameraDataModal(null) }>
                                <i className='fa fa-times'></i>
                            </button>
                        </Modal.Header>
                        <Modal.Body>
                            <div>
                                <div className="row mb-3">
                                    <div className="col-4">
                                        <p className="font-weight-semi-bold m-0">Read VRM</p>
                                    </div>
                                    <div className="col-8 d-flex align-items-center">
                                        <p className="small-number-plate m-0 ml-2"> { cameraDataModal.vrm }</p>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-4">
                                        <p className="font-weight-semi-bold m-0">Confidence</p>
                                    </div>
                                    <div className="col-8 d-flex align-items-center">
                                        <div class="progress" style={ { width: "100%" } }>
                                            <div class={ `progress-bar text-left pl-1 ${ cameraDataModal.confidence > 90 ? "bg-success" : (cameraDataModal.confidence > 60 ? "bg-warning" : "bg-danger") }` } role="progressbar" style={ { width: `${ cameraDataModal.confidence }%` } } aria-valuenow={ cameraDataModal.confidence } aria-valuemin="0" aria-valuemax="100">
                                                { cameraDataModal.confidence }%
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="row mb-3">
                                    <div className="col-4">
                                        <p className="font-weight-semi-bold m-0">Mac Address</p>
                                    </div>
                                    <div className="col-8 d-flex align-items-center">
                                        {cameraDataModal.cameraMacAddress}
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-4">
                                        <p className="font-weight-semi-bold m-0">Site</p>
                                    </div>
                                    <div className="col-8 d-flex align-items-center">
                                        {cameraDataModal.siteName}
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-4">
                                        <p className="font-weight-semi-bold m-0">Direction</p>
                                    </div>
                                    <div className="col-8 d-flex align-items-center">
                                        {cameraDataModal.direction}
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-4">
                                        <p className="font-weight-semi-bold m-0">Motion</p>
                                    </div>
                                    <div className="col-8 d-flex align-items-center">
                                        {cameraDataModal.motion}
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-4">
                                        <p className="font-weight-semi-bold m-0">ROI</p>
                                    </div>
                                    <div className="col-8 d-flex align-items-center">
                                        {cameraDataModal.roi}
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-4">
                                        <p className="font-weight-semi-bold m-0">Read Timestamp</p>
                                    </div>
                                    <div className="col-8 d-flex align-items-center">
                                        {!stringHelpers.isNullOrEmpty(cameraDataModal.timestamp) && toDateTimeString(cameraDataModal.timestamp, true)}
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-4">
                                        <p className="font-weight-semi-bold m-0">Received Timestamp</p>
                                    </div>
                                    <div className="col-8 d-flex align-items-center">
                                        {!stringHelpers.isNullOrEmpty(cameraDataModal.receivedTimestamp) && toDateTimeString(cameraDataModal.receivedTimestamp, true)}
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4">
                                        <p className="font-weight-semi-bold m-0">Seen count</p>
                                    </div>
                                    <div className="col-8 d-flex align-items-center">
                                        {stringHelpers.formatDecimal(cameraDataModal.seenCount, 0)}
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-4">
                                        <p className="font-weight-semi-bold m-0">Trace count</p>
                                    </div>
                                    <div className="col-8 d-flex align-items-center">
                                        {stringHelpers.formatDecimal(cameraDataModal.traceCount, 0)}
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-4">
                                        <p className="font-weight-semi-bold m-0">Reference</p>
                                    </div>
                                    <div className="col-8 d-flex align-items-center">
                                        {cameraDataModal.ref}
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-4">
                                        <p className="font-weight-semi-bold m-0">Preferred format</p>
                                    </div>
                                    <div className="col-8 d-flex align-items-center">
                                        {cameraDataModal.preferredFormat && <i className='fa fa-check text-success'></i>}
                                        {!cameraDataModal.preferredFormat && <i className='fa fa-times text-danger'></i>}
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-4">
                                        <p className="font-weight-semi-bold m-0">Is duplicate</p>
                                    </div>
                                    <div className="col-8 d-flex align-items-center">
                                        {cameraDataModal.isDuplicate && <i className='fa fa-check text-success'></i>}
                                        {!cameraDataModal.isDuplicate && <i className='fa fa-times text-danger'></i>}
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-4">
                                        <p className="font-weight-semi-bold m-0">Source Camera</p>
                                    </div>
                                    <div className="col-8 d-flex align-items-center">
                                        {cameraDataModal.srcCam}
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-4">
                                        <p className="font-weight-semi-bold m-0">Images</p>
                                    </div>
                                    <div className="col-8">
                                        {
                                            !arrayUtilities.isNullOrEmpty(cameraDataModal.imageUrls) && 
                                            <div className='d-flex flex-column'>
                                                <div><img height={75} src={cameraDataModal.imageUrls[1]} /></div>
                                                <div className='mt-2'><img width="100%" height="100%" src={cameraDataModal.imageUrls[0]} /></div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button onClick={ () => setCameraDataModal(null) } className='btn btn-primary'>Close</button>
                        </Modal.Footer>
                    </Modal>
                }
                {
                    showFiltersModal &&
                    <CameraDataFiltersModal
                        showModal={showFiltersModal}
                        handleClose={() => setShowFiltersModal(false)}
                        handleConfirm={(draftFilters) => {
                            setCameraFromDate(draftFilters.cameraFromDate)
                            setCameraToDate(draftFilters.cameraToDate)
                            setSiteId(draftFilters.siteId)
                            setSelectedCamera(draftFilters.selectedCamera)
                            setCameras(draftFilters.cameras)
                            setSelectedTags(draftFilters.selectedTags)
                            setDirection(draftFilters.direction)
                            setAppliedFilters(draftFilters.appliedFilters)
                            setShowFilterPills(true)
                            setShowFiltersModal(false)
                            setCameraPageNumber(0)
                            getCameraData(cameraSearch, draftFilters.siteId, draftFilters.cameraFromDate, draftFilters.cameraToDate, 0, draftFilters.selectedCamera, draftFilters.selectedTags, draftFilters.direction)
                        }}
                        initialCameraFromDate={cameraFromDate}
                        initialCameraToDate={cameraToDate}
                        initialSiteId={siteId}
                        initialSelectedCamera={selectedCamera}
                        initialCameras={cameras}
                        initialSelectedTags={selectedTags}
                        initialDirection={direction}
                        initialAppliedFilters={appliedFilters}
                        sites={props.sites}
                        tags={props.tags || []}
                        organisationId={props.organisationId}
                        token={props.token}
                        key="camera-data-filters-modal"
                    />
                }
            </div>
        </>
    )
}
export default CameraData;